import React from 'react'
import css from './style.css'
import _map from 'lodash/map'
import Spacer from '../spacer'
import { connect } from 'react-redux'
import HorizontalRule from '../horizontal-rule'
import * as actions from '../../actions/cart'
import * as summarySelectors from '../../selectors/summary'
import { OrderLine, OrderLineInput } from '../order-line'
import { DiamondName, JewelryName } from '../item-header'
import {
  getDiamondPrices,
  getJewelryPrices,
  getAppraisalCosts
} from '../../selectors/cart'

const mapStateToProps = (state, ownProps) => {
  return {
    appraisalCost: state.cart.appraisalCost,
    diamondPrices: getDiamondPrices(state),
    jewelryPrices: getJewelryPrices(state),
    appraisalCosts: getAppraisalCosts(state),
    subtotal: summarySelectors.getSubtotal(state),
    taxPercent: state.cart.taxPercent,
    taxAmount: summarySelectors.getTaxAmount(state),
    grandTotal: summarySelectors.getGrandTotal(state),
    depositAmount: summarySelectors.getDepositAmount(state),
    diamondsForCheckout: summarySelectors.getDiamondsForCheckout(state),
    jewelryForCheckout: summarySelectors.getJewelryForCheckout(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cartFieldChanged: (field, value) => {
      dispatch(actions.cartFieldChanged(field, parseFloat(value.target.value)))
    }
  }
}

const OrderTally = props => {
  let diamonds = _map(props.diamondsForCheckout, (value, key) => ({
    name: <DiamondName data={value.data} />,
    price: props.diamondPrices[key]
  }))

  let jewelry = _map(props.jewelryForCheckout, (jewel, key) => ({
    name: <JewelryName data={jewel.data} index={key} />,
    price: props.jewelryPrices[key],
    appraisalCost: props.appraisalCosts[key]
  }))

  return (
    <div className={css.container}>
      {jewelry.map((item, index) => (
        <div key={`jewelry${index}`}>
          <OrderLine price={item.price} name={item.name} />
          <OrderLine price={item.appraisalCost} name='Appraisal Cost' />
        </div>
      ))}
      {diamonds.map((item, index) => (
        <OrderLine price={item.price} key={`diamond${index}`} name={item.name} />
      ))}
      <HorizontalRule />
      <OrderLine name='Pre-Tax Total' price={props.subtotal} total />
      <OrderLineInput
        name='Tax Rate'
        value={props.taxPercent}
        suffix='%'
        min={0}
        step={0.01}
        onChange={props.cartFieldChanged.bind(this, 'taxPercent')} />
      <OrderLine name='Tax ' price={props.taxAmount} />
      <HorizontalRule />
      <OrderLine name='Total' price={props.grandTotal} total grandTotal />
      <HorizontalRule />
      <Spacer custom={3} />
      <OrderLineInput
        name='Deposit'
        value={props.depositAmount}
        prefix='$'
        min={0}
        onChange={props.cartFieldChanged.bind(this, 'customDepositAmount')}
      />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderTally)



// WEBPACK FOOTER //
// ./src/components/order-tally/index.js